import { environment } from 'src/environments/environment';

export const authConfig: any = {
  issuer: environment.authority,
  redirectUri: window.location.origin + '/login?loading=true',
  postLogoutRedirectUri: window.location.origin + '/login',
  responseType: 'code',
  sessionChecksEnabled: true,
  clientId: environment.clientId,
  scope: 'openid profile email',
  clearHashAfterLogin: false,
  requireHttps: false,
  strictDiscoveryDocumentValidation: false
};
